import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { Observable } from 'rxjs';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { ViewService } from '../../view.service';
import { LabelPinType } from 'src/app/story/models/labels/label-pin-type.enum';
import { LabelSequentialType } from 'src/app/story/models/labels/label-sequential-type.enum';

@Component({
  selector: 'app-view-labels',
  templateUrl: './view-labels.component.html',
  styleUrls: ['./view-labels.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewLabelsComponent implements OnInit {
  labelPinType = LabelPinType;
  labelSequentialtype = LabelSequentialType;

  @Select(StoryLabelsState.getChapterLabels)
  labels$: Observable<LabelModel[]>;

  @Select(StoryLabelsState.getSelectedLabel)
  selectedLabel$: Observable<LabelModel>;


  constructor(
    private viewService: ViewService,
    private store: Store
  ) { }

  ngOnInit() {
  }

  getLabelSequence(label: LabelModel) {
    return this.store.selectSnapshot(StoryLabelsState.getLabelSequence(label)); 
  }

  handleLabelClick(label: LabelModel) {
    this.viewService.selectLabel(label, true);
  }

}
